<style lang="scss" scoped>
.buy-wrapper{
  margin-top: 62px;
  position: relative;
  &-content{
    width: 100%;
    margin-top: 30px;
    &-top{
      position: relative;
      margin: 0 auto;
      width: 960px;
      height: 504px;
      background:rgba(31,55,91,1);
      border-radius:8px;
      margin-top: 27px;
      margin-bottom: 12px;
      &-book{
        position: absolute;
        width: 138px;
        height: 78px;
        top: -49px;
        left: -69px;
      }
      &-tag{
        position: absolute;
        right: 0;
        top: 24px;
        display: inline-block;
        height: 38px;
        padding: 0 9px;
        background:rgba(252,196,13,1);
        border-radius:100px 0px 0px 100px;
        font-size:16px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(69,72,77,1);
        line-height:38px;
      }
      &-img{
        width: 100%;
        height: 100%;
        border-radius:8px;
      }
    }
    &-bottom{
      width: 960px;
      height: 509px;
      margin: 0 auto;
      background: url('./../assets/img/group22.svg');
      background-size: cover;
      margin-top: 60px;
      ul{
        // text-align: center;
        width: 100%;
        height: 100%;
        padding: 91px 40px 23px 281px;
        box-sizing: border-box;
        li{
          margin-bottom: 32px;
          position: relative;
          transform: translateX(10px);
          text-align: left;
          span{
            width: 100%;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size:20px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(235,240,246,1);
            line-height:28px;
            text-decoration:underline;
            cursor: pointer;
          }
          &::before{
            content: '';
            width:8px;
            height:8px;
            background:rgba(253,164,39,1);
            border-radius: 2px;
            position: absolute;
            top: 50%;
            margin-top: -2px;
            transform: translateX(-26px);
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="buy-wrapper" id="buy">
    <div class="wrapper-reset">
      <Title v-if="buyData.title" :title="buyData.title"></Title>
      <div class="buy-wrapper-content">
        <div class="buy-wrapper-content-top">
          <img class="buy-wrapper-content-top-book" src="./../assets/img/book-pc.svg" alt="">
          <span class="buy-wrapper-content-top-tag"  v-if="count">{{count}}人参与</span>
          <img class="buy-wrapper-content-top-img" v-if="buyData" :src="buyData.cover" alt="">
        </div>
        <BigButton :text="buyData.button" :link="buyData.buttonLink" @click.native="statistics"></BigButton>
        <div class="buy-wrapper-content-bottom">
          <ul>
            <li v-for="(item, index) in buyData.itemList">
              <span @click="statisticsLink(index, item.link)">{{item.title}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/Title';
import BigButton from '@/components/bigButton'
export default {
  data() {
    return {
      count: 0,
      buyData: {},
    }
  },
  components: {
    Title,
    BigButton,
  },
  methods: {
    statistics() {
      this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_buy_buy_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}}).then((res) => {
        this.count++;
      })
    },
    statisticsLink(index, link) {
      window.open(link);
      this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_buy_link'+(index+1)+'_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}});
    }
  },
  mounted () {
    this.$bus.on('buyData', (data) => {
      this.buyData = data;
    });
    this.$http.userCount({actId: this.$str('actId')}).then((res) => {
      this.count = res.data.count;
    })
    setInterval(() => {
      this.$http.userCount({actId:543}).then((res) => {
        this.count = res.data.count;
      })
    }, 30000)
  }
}
</script>



// WEBPACK FOOTER //
// src/blocks/Buy.vue